import { useCallback, useRef, useState } from "react";

import { FolderDropResource } from "js/react/views/SharedResources/utils/folderDropHelpers";

export function useFolderDragItems<T>(mapItem: (item: T) => FolderDropResource) {
    const [draggedItems, setDraggedItems] = useState<FolderDropResource[]>([]);
    const activeDragItemsRef = useRef<FolderDropResource[]>([]);

    const handleStartDragItems = useCallback((items: T[]) => {
        const folderDropItems = items.map(mapItem);
        activeDragItemsRef.current = folderDropItems;
        setDraggedItems(folderDropItems);
    }, [mapItem]);

    const handleDropDragItems = useCallback(() => {
        setDraggedItems([]);
    }, []);

    const clearDragItems = useCallback(() => {
        activeDragItemsRef.current = [];
        setDraggedItems([]);
    }, []);

    const getActiveDragItems = useCallback(() => activeDragItemsRef.current, []);

    return {
        draggedItems,
        handleStartDragItems,
        handleDropDragItems,
        clearDragItems,
        getActiveDragItems,
    };
}
